import * as DG from 'datagrok-api/dg';
import { SeqTemps } from './macromolecule/seq-handler';
import { MONOMER_CANONICALIZER_FUNC_TAG } from './macromolecule/consts';
export function splitAlignedSequences(sequenceColumn, seqHelper) {
    const getCol = (index) => columnList[index] ?? null;
    const createCol = (index) => {
        const positionCol = resultDf.columns.addNewString((index + 1).toString());
        columnList.push(positionCol);
        return positionCol;
    };
    const columnList = [];
    const rowCount = sequenceColumn.length;
    const resultDf = DG.DataFrame.create(rowCount);
    const uh = seqHelper.getSeqHandler(sequenceColumn);
    for (let rowIdx = 0; rowIdx < rowCount; ++rowIdx) {
        const currentMonomerList = uh.getSplitted(rowIdx);
        for (let posIdx = 0; posIdx < currentMonomerList.length; ++posIdx) {
            const om = currentMonomerList.getOriginal(posIdx);
            const col = getCol(posIdx) || createCol(posIdx);
            col.set(rowIdx, om, false);
        }
    }
    // If the notation provider specifies a monomer canonicalizer, tag all monomer columns
    const notationProvider = sequenceColumn.temp[SeqTemps.notationProvider] ?? null;
    const canonFuncName = notationProvider?.monomerCanonicalizerFuncName;
    if (canonFuncName)
        for (const col of columnList)
            col.setTag(MONOMER_CANONICALIZER_FUNC_TAG, canonFuncName);
    return resultDf;
}
//# sourceMappingURL=splitter.js.map